import { Toaster as Sonner } from 'sonner';
import { useTheme } from '../theme.js';

/** Toasts do console (sonner), no tema resolvido e com as cores dos tokens. */
export function Toaster() {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group !border-border !bg-card !text-foreground !shadow-float !rounded-lg !text-sm',
          description: '!text-muted-foreground',
          success: '[&_[data-icon]]:!text-success',
          error: '[&_[data-icon]]:!text-danger',
          warning: '[&_[data-icon]]:!text-warning',
        },
      }}
    />
  );
}
